<template>
    <div style="z-index: 100;" v-if="visible" class="popup">
        <div class ="popup-card">
            <div class ="top_bar">
                <p class="title">LE-TIMES Consultancy</p>
                <button class="close-button" @click="closePopup">
                    <img :src="require(`@/assets/icon/close.png`)" alt="icon" class="icon" />
                </button>
            </div>
            <div class ="popinfo">
                <div class="intro">
                    <p class = "info_text">
                        We offer best quality service for all marketing areas across social media, websites, brochures etc.<br/><br/>
                    We have most skillful AV team with plenty shooting/editing experience.<br/><br/>
                    We develop creative shooting plan to cater every customer’s special needs!</p>
                </div>
                <div class="vertiLine">

                </div>
                <div class="connect_us">
                    <div class="connect_title">
                        <p>
                            for more information...
                        </p>
                        <p>
                            PLEASE CONTACT US
                        </p>
                    </div>
                    <div class = "connect_info">
                        <div class="photo_group">
                            <img src="../assets/qrcode.png" class="qrcode" />
                            <p class = "photo_name">LeTimes乐港文化</p>
                        </div>
                        <div class="info_bar">
                            <p class = "info_text">DavidHan</p>
                            <p class = "info_text">Mobile: 13611390948</p>
                            <p class = "info_text">Email: david.han@le-times.com</p>
                            <p class = "info_text">Website: www.le-times.com</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

  
<script scoped>
  export default {
    name: 'ShootingPage',
    props:{
        visible: {
            type: Boolean,
            default: false
        },
        content: {
            type: String,
            default: ''
        }
    },
    data() {
      return {
        
      };
    },
    methods: {
        closePopup() {
            this.$emit('close');
        }
    },
  }
</script>
  
<style scoped>

.popup {
        position: fixed;
        flex-wrap: wrap;      /*  */
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .popup-card{
        display: flex;
        flex-direction:column;
        width: 50%;
        height: 40%;
        background: rgba(79, 77, 77, 0.9);
    }
    .top_bar{
        display: flex;
        flex-direction:row;
        align-items: center;
        justify-content: space-between;
        height: 60px;
        background-color: rgba(0,0,0,0.2);
    }
    .popinfo{
        display: flex;
        flex-direction:row;
        padding:16px;
        font-size: 1rem;

    }
    .intro{
        justify-content: left;
        align-items: center;
        font-size: 1rem;
        width: 45%;
        margin-left:  32px;
        margin-top: 16px;
        margin-right: 32px

    }
    .vertiLine{
        width:2px;
        height: calc(40vh-48px-32px);
        background-color: white;
    }
    .connect_us{
        margin-left: 32px;
        display: flex;
        flex-direction:column;
        margin-top:16px;

    }
    .connect_title{
        display: flex;
        flex-direction:column;
        text-align: left;
        color:white;
        font-size: 1.2rem;
    }
    .connect_info{
        display: flex;
        flex-direction:row;
        text-align: left;
        color:white;
        padding-top: 16px;
    }
    .close-button {
        background-color:rgba(0,0,0,0) ;
        margin: 6px;
        margin-right: 22px;
        width:32px;
        height:32px;
        overflow: hidden;
        border: none;
    }
    .close-button:hover{
        background-color:rgba(42, 42, 42, 0.5);
    }
    .icon {
        padding:2px;
        width: 100%; /* 让图标适应父容器 */
        height: 100%;
        object-fit: cover; /* 保持图片比例并填满按钮 */
    }
    .title{
        color: white;
        font-size: 1.2%;
        margin-left: 16px;
    }
    .info_bar{
        margin-left: 16px;
    }
    .info_text{
        color: white;
        text-align: left;
    }
    .photo_group{
        overflow-y: hidden;
        width:32%;
        height:100%;
    }
    .photo_name{
        color: white;
        text-align: center;
    }
    .qrcode{
        width: 100%;
        aspect-ratio: 1/1;
    }
    @media (max-width: 768px) {
        .popup-card{
            display: flex;
            flex-direction:column;
            
            width: 80%;
            height: 80%;
            background: rgba(79, 77, 77, 0.9);
        }
        .top_bar{
            height:64px;
        }
        .intro{
            width:100%;
            margin:0px;
        }
        .popinfo{
            display: flex;
            flex-direction:column;
            padding:16px;
            font-size:1rem;
        }
        .vertiLine{
            margin:0px;
            width:100%;
            height: 2px;
            margin-top: 16px;
        }
        .qrcode{
            width: 100%;
        }
        .connect_us{
            margin-left: 0px;
            display: flex;
            flex-direction:column;
            margin-top:16px;
        }
    }

</style>